import React, { useState } from 'react';
import {
    LocationInput,
    JobSearchAutocompleteInput,
    Button,
    Heading,
    Grid,
    GridColumn,
    View,
    Icon,
} from '@fairygodboss/ui';

import PropTypes from 'prop-types';
import './JobSearchBar.scss';
import './LocationInput.scss';

export const JobSearchBar = ({
    handleSubmit,
    headerText,
    query: queryProp,
    searchPlaceholder,
    locationInputPlaceholder,
    // searchBarTitle,
    location: locationProp,
    // ...others
}) => {
    const [query, setQuery] = useState(queryProp);
    const [location, setLocation] = useState({ value: locationProp });

    const handleLocationChange = (loc) => {
        setLocation(loc);
    };

    const handleQueryChange = (e) => {
        setQuery(e.target.value);
    };

    const handleFormSubmit = () => {
        handleSubmit({
            keywords: query,
            location,
        });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e?.target?.blur();
            if (e.target?.placeholder !== 'Anywhere') {
                e?.target?.focus();
            }
            handleSubmit({
                keywords: query,
                location,
            });
        }
    };

    return (
        <View position="relative" width="100%" backgroundColor="#2A4473">
            <Grid
                padding={{ xs: '16px 24px', sm: '24px 0px' }}
                justifyContent="center"
                // width={{ sm: '312px', md: '100%' }}
            >
                <GridColumn
                    size={{ md: 12, xl: 12 }}
                    display={{ sm: 'block', xs: 'none' }}
                >
                    <Heading
                        data-qa="Jobs-Searchbar-Heading"
                        color="#ffffff"
                        textAlign="center"
                        marginBottom="11px"
                        fontFamily="'Open Sans', 'Helvetica Neue', 'Helvetica', Arial, sans-serif"
                        variant="headingSm"
                    >
                        {headerText}
                    </Heading>
                </GridColumn>
                <Grid>
                    <GridColumn
                        size={{ _: 12, md: 4 }}
                        minWidth="316px"
                        marginLeft={{ xl: '0px' }}
                        display="flex"
                        justifyContent="center"
                        px="8px"
                    >
                        <View width={{ _: '312px', md: '300px' }}>
                            <JobSearchAutocompleteInput
                                changeHandler={handleQueryChange}
                                placeholder={searchPlaceholder}
                                onKeyDown={handleKeyDown}
                                value={query}
                            />
                        </View>
                    </GridColumn>
                    <GridColumn
                        minWidth="316px"
                        size={{ _: 12, md: 4 }}
                        paddingTop={{ s: '10px', md: '0px' }}
                        paddingBottom={{ s: '16px', md: '0px' }}
                        display="flex"
                        justifyContent="center"
                        px="8px"
                    >
                        <View width={{ _: '312px', md: '300px' }}>
                            <LocationInput
                                changeHandler={handleLocationChange}
                                placeholder={locationInputPlaceholder}
                                value={location?.value || ''}
                                onKeyDown={handleKeyDown}
                            />
                        </View>
                    </GridColumn>
                    <GridColumn
                        size={{ _: 12, md: 2 }}
                        maxWidth={{ md: '163px' }}
                        display="flex"
                        justifyContent="center"
                        px="8px"
                    >
                        <View width={{ _: '312px', md: '147px' }}>
                            <Button
                                data-qa="Jobs-Searchbar-Find-Jobs-Button"
                                variant="secondary"
                                height="48px"
                                borderRadius="24px"
                                width="100%"
                                fontFamily="'Open Sans', 'Helvetica Neue', 'Helvetica', Arial, sans-serif"
                                onPress={(e) => {
                                    e.preventDefault();
                                    return handleFormSubmit();
                                }}
                                onKeyDown={handleKeyDown}
                                rightIcon={<Icon variant="arrow_right_16" />}
                                stretchContent
                            >
                                Find Jobs
                            </Button>
                        </View>
                    </GridColumn>
                </Grid>
            </Grid>
        </View>
    );
};

JobSearchBar.displayName = 'JobSearchBar';

JobSearchBar.propTypes = {
    /**
     * Handle form submit
     */
    handleSubmit: PropTypes.func.isRequired,
    /**
     * Text for the header of the component
     */
    headerText: PropTypes.string,
    /**
     * the query to be searched (keywords)
     */
    query: PropTypes.string,
    /**
     * Placeholder for the search input
     */
    searchPlaceholder: PropTypes.string,
    /**
     * Location Input place holder
     */
    locationInputPlaceholder: PropTypes.string,
    /**
     * Initial Location
     */
    location: PropTypes.string,
    // location: PropTypes.shape({
    //     coordinates: PropTypes.shape({
    //         lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    //         lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    //     }),
    //     value: PropTypes.string,
    // }),
};

JobSearchBar.defaultProps = {
    query: '',
    // handleSubmit: () => {},
    headerText: 'Find jobs at companies that want to hire women.',
    searchPlaceholder: 'Search for Job title or Keyword',
    locationInputPlaceholder: 'Anywhere',
    location: '',
};
